import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  user: null,
  isShowDepositPopup: false,
};

// Tạo slice
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCurrentUser: (state, action) => {
      state.user = action.payload;
      state.isAuthenticated = action.payload !== null;
    },
    setProfileShowDeposit: (state, action) =>{
      state.isShowDepositPopup = action.payload;
    },
  },
});

// Xuất actions và reducer
export const { setCurrentUser, setProfileShowDeposit } = authSlice.actions;
export default authSlice.reducer;
